import { InjectionToken, Signal } from '@angular/core';
import { Observable } from 'rxjs';
import { ProjectJourneyEvent } from '@lite-workspace/dto-fotoclass-common';

/**
 * Transport port the store depends on instead of a concrete Socket.IO client — the real socket
 * connection is an app-level singleton (`apps/frontend/admin/src/app/core/socket.service.ts`) and
 * a domain lib cannot import from an app, so the app binds its `SocketService` to this token.
 */
export interface ProjectJourneySocketPort {
  readonly connected: Signal<boolean>;
  /** Emits on every re-connect after a drop (not on the first connect). */
  readonly reconnected$: Observable<void>;
  connect(): void;
  /** Reference-counted: safe to call once per interested consumer of the same projectId. */
  joinRoom(projectId: string): Observable<ProjectJourneyEvent>;
  leaveRoom(projectId: string): void;
}

export const PROJECT_JOURNEY_SOCKET = new InjectionToken<ProjectJourneySocketPort>('PROJECT_JOURNEY_SOCKET');
